import React from 'react';
import { Container, Row, Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Section, SpinnerArea } from '../../shared/components';
import useService from '../../shared/hooks/useService';
import indicatorsService from '../../services/operIndicatorsService';
import { EsgIndicatorGridDto } from '../../services/types/EsgIndicators';
import IndicatorGridValue from './IndicatorGridValue';

const renderIndicatorRows = (datos: EsgIndicatorGridDto[]) =>
  datos.map((i) => <IndicatorGridValue dto={i} />);

const GridCell: React.FC<{ content: React.ReactNode }> = ({ content }) => {
  const { t } = useTranslation();
  return (
    <div className="grid-indicators-table-container">
      <Table className="grid-indicators-table">
        <thead>
          <tr>
            <th>{t('Indicator')}</th>
            <th>{t('Value')}</th>
          </tr>
        </thead>
        <tbody>{content}</tbody>
      </Table>
    </div>
  );
};

const DynamicGrid: React.FC<{ dtos: EsgIndicatorGridDto[] }> = ({ dtos }) => {
  const totalDtos = dtos.length;
  const itemsPerCell = Math.ceil(totalDtos / 3);

  const cell1Data = dtos.slice(0, itemsPerCell);
  const cell2Data = dtos.slice(itemsPerCell, itemsPerCell * 2);
  const cell3Data = dtos.slice(itemsPerCell * 2);

  return (
    <div className="dynamic-grid">
      <GridCell content={renderIndicatorRows(cell1Data)} />
      <GridCell content={renderIndicatorRows(cell2Data)} />
      <GridCell content={renderIndicatorRows(cell3Data)} />
    </div>
  );
};

const IndicatorModal: React.FC<{ operationId: number; queryDate: string }> = ({
  operationId,
  queryDate,
}) => {
  const [data, loading] = useService(async () =>
    indicatorsService.getIndicatorsStatusByOperation(operationId, queryDate)
  );

  return (
    <Container>
      <Row className="indicator-row">
        <Section className="card-body-indicators">
          <SpinnerArea loading={loading}>{data && <DynamicGrid dtos={data} />}</SpinnerArea>
        </Section>
      </Row>
    </Container>
  );
};

export default IndicatorModal;
